import { Component, OnInit } from '@angular/core';
import {
  RatingEditorService,
  GameType,
  RatingStatus,
  DescriptiveDataBackEnd, RatingBallsRowBackEnd
} from '../../../services/rating-editor.service';
import {ExternalStylesCustomSelect} from '../../UI/custom-select/custom-select.component';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  Observable,
  of,
  OperatorFunction,
  switchMap
} from 'rxjs';
import {LocationsService} from '../../../services/locations.service';

@Component({
  selector: 'app-rating-editor-form',
  templateUrl: './rating-editor-form.component.html',
  styleUrls: ['./rating-editor-form.component.scss'],
})
export class RatingEditorFormComponent implements OnInit {

  constructor(
    private pageService: RatingEditorService,
    private locationsService: LocationsService,
  ) { }

  public labelsSet = {
    ratingName: 'Название рейтинга',
    ratingStatus: 'Статус рейтинга',
    country: 'Страна',
    city: 'Город',
    game: 'Игра',
    tournaments: 'Турниры',
  }

  public selectedTournamentsHeader = 'Турниры: ';

  public valuesToDisplayForTypeAhead = {
    country: null,
    city: null,
  }

  private _hoveredIndex = -1;


  public typedTournamentName = '';

  public labelsClasses = {

  }

  public tournamentsListToDisplay: any[] = [];

  private _focusedInput: HTMLElement;
  private _tournamentSearchTimeOut;
  private _textFieldMutationObserver: MutationObserver = new MutationObserver(
    (mutationsList, observer) => {
    const rawClassList = mutationsList[0].target['classList'];
    const trueClassList = Array.from(rawClassList);
    if(trueClassList.includes('open')) {
      rawClassList.remove('open');
    }
  });

  private _elevatedLabelStyleName = 'elevatedLabelStyle';

  private _listElementWasClicked = false;

  public customStylesSelect: ExternalStylesCustomSelect = {
    elementWrapperStyle: {
      borderRadius: '0',
      border: '0.1px solid gray',
    },
    iconContainerStyle: {
      borderLeft: '0px'
    },
    optionsWrapperStyle: {
      borderRadius: '0',
    }
  }

  public identifiersSet = {
    ratingName: 'ratingNameInputId',
    ratingStatus: 'ratingStatusInputId',
    country: 'countryInputId',
    city: 'cityInputId',
    game: 'gameInputId',
    tournaments: 'tournamentsInputId',
  }

  noRatingNameSpecified() {
    return this.pageService.noRatingNameSpecified();
  }

  noRatingStatusSpecified() {
    return this.pageService.noRatingStatusSpecified();
  }

  noRatingCountrySpecified() {
    return this.pageService.noRatingCountrySpecified();
  }

  noRatingCitySpecified() {
    return this.pageService.noRatingCitySpecified();
  }

  noRatingGameTypeSpecified() {
    return this.pageService.noRatingGameTypeSpecified();
  }



  public errorLabelFlags = {
    [this.identifiersSet.ratingName]: false,
    [this.identifiersSet.ratingStatus]: false,
    [this.identifiersSet.country]: false,
    [this.identifiersSet.city]: false,
    [this.identifiersSet.game]: false,
  }


  private _isTypeAhead = {
    [this.identifiersSet.ratingName]: false,
    [this.identifiersSet.ratingStatus]: false,
    [this.identifiersSet.country]: true,
    [this.identifiersSet.city]: true,
    [this.identifiersSet.game]: false,
  }




  public errorLabelHandlers = {
    [this.identifiersSet.ratingName]: this.noRatingNameSpecified.bind(this),
    [this.identifiersSet.ratingStatus]: this.noRatingStatusSpecified.bind(this),
    [this.identifiersSet.country]: this.noRatingCountrySpecified.bind(this),
    [this.identifiersSet.city]: this.noRatingCitySpecified.bind(this),
    [this.identifiersSet.game]: this.noRatingGameTypeSpecified.bind(this),
  }

  onOpen(opened: boolean, id: string) {
    this.pageService.someFieldWasTouched = true;
    this.errorLabelFlags[id] = opened
      ? !opened
      : this.errorLabelHandlers[id]();
  }

  private _errorMessages = {
    [this.identifiersSet.ratingName]: 'Обязательно к заполнению',
    [this.identifiersSet.ratingStatus]: 'Обязательно к заполнению',
    [this.identifiersSet.country]: 'Требуется выбрать из списка',
    [this.identifiersSet.city]: 'Требуется выбрать из списка',
    [this.identifiersSet.game]: 'Обязательно к заполнению',
  }


  private _selectedOptions: SelectedOptions = {
    selectedStatus: null,
    selectedGameType: null,
  }

  public optionsTransformersSet = {
    ratingStatus: (status: RatingStatus) => status?.title,
    gameType: (type: GameType) => type?.title,
  }

  ngOnInit(): void {
    const searchParameters = new URLSearchParams(window.location.search);
    const edit =  searchParameters.get('edit') === 'true';

    if (edit) {
      this.pageService.ratingIdToModify = searchParameters.get('ratingId');
      this.pageService.getRatingDescriptiveData().subscribe((descriptiveData: DescriptiveDataBackEnd) => {
        this.pageService.allDescriptiveData = descriptiveData;
        const typedAndSelectedValues = this.pageService.typedAndSelectedValues;

        typedAndSelectedValues.ratingName = descriptiveData?.title;
        typedAndSelectedValues.ratingCountry = descriptiveData?.country;
        typedAndSelectedValues.ratingGameType = descriptiveData?.game;
        typedAndSelectedValues.ratingStatus = descriptiveData?.status;
        typedAndSelectedValues.ratingTournamentsIdsList
          = descriptiveData?.tournaments?.map(tournament => tournament?.id);
        typedAndSelectedValues.ratingCity = descriptiveData?.city;
        typedAndSelectedValues.ratingDateFrom = descriptiveData?.date_from;
        typedAndSelectedValues.ratingDateTo = descriptiveData?.date_to;

        this.selectedStatus = {
          id: descriptiveData.status_data.statusId,
          title: descriptiveData.status_data.statusName,
        };

        this.selectedGameType = {
          id: descriptiveData.game_data.gameId,
          title: descriptiveData.game_data.gameName,
        }

        this.tournamentsListToDisplay = descriptiveData?.tournaments;

        this.valuesToDisplayForTypeAhead.city = {
          id: descriptiveData.city_data.cityId,
          name: descriptiveData.city_data.cityName,
        }

        this.valuesToDisplayForTypeAhead.country = {
          id: descriptiveData.country_data.countryId,
          name: descriptiveData.country_data.countryName,
        }

        });
    }
  }

  getRatingStatusesList() {
    return this.pageService.ratingStatusesList;
  }

  getGameTypesList() {
    return this.pageService.gamesList;
  }


  public typeAheadSelectHandlers = {
    citySelect: (event) => {
      const selectedCity = event?.item;
      const selectedCityId = selectedCity?.id;

      const selectedCountry = selectedCity?.region?.country;
      const selectedCountryId = selectedCountry?.id;

      this.pageService.typedAndSelectedValues.ratingCity = selectedCityId;
      this.pageService.typedAndSelectedValues.ratingCountry = selectedCountryId;

      this.valuesToDisplayForTypeAhead.city = selectedCity;
      this.valuesToDisplayForTypeAhead.country = selectedCountry;
      this._listElementWasClicked = true;

    },
    countrySelect: (event) => {
      const selectedCountry = event?.item;
      this.pageService.typedAndSelectedValues.ratingCountry = selectedCountry?.id;
      this.valuesToDisplayForTypeAhead.country = selectedCountry;
      this._listElementWasClicked = true;
      this.valuesToDisplayForTypeAhead.city = null;
      this.pageService.typedAndSelectedValues.ratingCity = null;
    },
    tournamentSelect: (event) => {
      const selectedTournamentItem = event?.item;
      this.pageService
        .typedAndSelectedValues
        .ratingTournamentsIdsList
        .push(selectedTournamentItem?.id);

      this.tournamentsListToDisplay.push(selectedTournamentItem);

    },
  }

  public typeAheadDataTransformers = {
    cityInputFormatter: (city) => city.name || city,
    cityResultFormatter: (city) => `${city.name}, ${city.region.name}, ${city.region.country.name}`,
    tournamentInputFormatter: (tournament) => tournament?.name,
    tournamentResultFormatter: (tournament) => tournament?.name,
    countryInputFormatter: (country) => country?.name,
    countryResultFormatter: (country) => country?.name
  }

  searchCity: OperatorFunction<string, any> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term) => {
        const trimmedQuery = term.trim();
        if (trimmedQuery) {
          return this.locationsService
            .get(
              trimmedQuery,
              this.valuesToDisplayForTypeAhead?.country?.id
            )
            .pipe(
              catchError(() => {
                return of([]);
              })
            );
        }
        return of([]);
      }),
      map((response: any) => {
        return response.results
      })
    );

  searchTournament: OperatorFunction<string, any> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term) => {
        const trimmedQuery = term.trim();
        if (trimmedQuery) {
          return this
            .pageService
            .getFilteredTournamentsList(trimmedQuery)
            .pipe(
              catchError(() => {
                return of([]);
              })
            );
        }
        return of([]);
      }),
      map((response: any) => {
        return response
          ?.filter(
            tournamentItem =>
              !this.pageService
                .typedAndSelectedValues
                .ratingTournamentsIdsList.includes(tournamentItem?.id)
          );
      }),
    );

  searchCountry: OperatorFunction<string, any> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term) => {
        const trimmedQuery = term.trim();
        if (trimmedQuery) {
          return this.locationsService
            .searchCountries(trimmedQuery)
            .pipe(
              catchError(() => {
                return of([]);
              })
            );
        }
        return of([]);
      }),
      map((response: any) => {
        return response?.results;
      })
    );

  textInputFocusHandler($event) {

    this._listElementWasClicked = false;
    this.pageService.someFieldWasTouched = true;

    this._focusedInput = $event?.target;
    const id = $event.target.id;

    if (this.errorLabelFlags[id] !== undefined) {
      this.errorLabelFlags[id] = false;
    }

    this.findNeighbourByNodeName(this._focusedInput, 'LABEL')
      .classList.add(this._elevatedLabelStyleName);
    this._textFieldMutationObserver.observe(this._focusedInput, {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      characterData: false
    })
  }

  textInputBlurHandler($event) {
    this._textFieldMutationObserver.disconnect();
    const id = $event.target.id;
    const functionToExecute = this.errorLabelHandlers[id];

    if (typeof functionToExecute === 'function') {
      this.errorLabelFlags[id] = functionToExecute();
    }

    if (this._isTypeAhead[id]) {
      if (!this._listElementWasClicked) {
        this.errorLabelFlags[id] = true;
        if (id === this.identifiersSet.country) {
          this.pageService.typedAndSelectedValues.ratingCountry = null;
        } else if(id === this.identifiersSet.city) {
          this.pageService.typedAndSelectedValues.ratingCity = null;
        }
      }
    }
    if (!$event?.target.value) {
      this.findNeighbourByNodeName(this._focusedInput, 'LABEL')
        .classList.remove(this._elevatedLabelStyleName);
    }
  }

  findNeighbourByNodeName(elementToFindNextTo: Element, nodeName: string): Element {
    const trueChildrenList = Array.from(elementToFindNextTo.parentNode?.children);
    return trueChildrenList.find(element => element?.nodeName === nodeName);
  }



  labelClickHandler($event) {
    const clickedLabel = $event?.target;
    //@ts-ignore
    this.findNeighbourByNodeName(clickedLabel, 'INPUT').focus();
  }


  get selectedStatus(): RatingStatus {
    return this._selectedOptions.selectedStatus;
  }

  get selectedGameType(): GameType {
    return this._selectedOptions.selectedGameType;
  }

  set selectedStatus(value: RatingStatus) {
    this.pageService.typedAndSelectedValues.ratingStatus = value.id;
    this._selectedOptions.selectedStatus = value;
  }

  set selectedGameType(value: GameType) {
    this.pageService.typedAndSelectedValues.ratingGameType = value.id;
    this._selectedOptions.selectedGameType = value;
  }

  get ratingName() {
    return this.pageService.typedAndSelectedValues.ratingName;
  }

  set ratingName(value) {
    this.pageService.typedAndSelectedValues.ratingName = value;
  }

  noTournamentsWereSelected(): boolean {
    return !this.pageService.typedAndSelectedValues.ratingTournamentsIdsList?.length;
  }

  tournamentStyleOnHover(index: number) {
    return index === this._hoveredIndex ? 'tournamentHoverClass' : '';
  }

  setIndexOnHover(index: number) {
    this._hoveredIndex = index;
  }

  clearIndexOnHover() {
    this._hoveredIndex = -1;
  }

  onTournamentDelete(index: number) {
    this.tournamentsListToDisplay.splice(index, 1);
    this.pageService.typedAndSelectedValues.ratingTournamentsIdsList.splice(index, 1);
    this.pageService.someFieldWasTouched = true;
  }

  getCertainErrorMessage(id: string) {
    return this._errorMessages[id];
  }

  cityDisabled() {
    return this.pageService.ratingCityDisabled();
  }

  countryDisabled() {
    return this.pageService.ratingCountryDisabled();
  }

  inactiveLabelStyle(flag: boolean) {
    return flag ? 'inactiveLabelStyle' : '';
  }

}

interface SelectedOptions {
  selectedStatus?: RatingStatus,
  selectedGameType?: GameType,
}
